import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { merge } from 'rxjs';
import { filter } from 'rxjs/operators';
import type { Action } from 'state/actions';
import type { AppState } from 'state/state.model';

import { tabRemoved } from './tabRemoved';

export function quoteOrTabRemoved(
  action$: Observable<Action>,
  tabId: string,
  quoteId: string,
  state$: Observable<AppState>,
) {
  const tabRemoved$ = tabRemoved(action$, tabId, state$);

  const quoteRemoved$ = action$.pipe(
    ofType('ADDON_QUOTE_REMOVED', 'QUOTE_REMOVED'),
    filter(action => action.quoteId === quoteId && action.tabId === tabId),
  );

  return merge(quoteRemoved$, tabRemoved$);
}
